import { styled, Typography, Box } from '@mui/material';
import fonts from '../../themes/fonts';
import colors from '../../themes/colors';

export const Text = styled(Typography)(({ theme }) => ({
  fontSize: '15px',
  fontFamily: fonts.Medium,
}));
export const Label = styled(Text)(({ theme }) => ({
  color: colors.gray,
}));
export const LabelStrong = styled(Text)(({ theme }) => ({
  color: colors.gray,
  fontFamily: fonts.DemiBold,
}));
export const Title = styled(Text)(({ theme }) => ({
  color: colors['greyish-brown'],
  fontFamily: fonts.Bold,
  fontSize: '20px',
  margin: '8px 0px 16px 0px',
}));
export const FormControl = styled(Box)(({ theme }) => ({
  margin: '4px 0px',
}));
export const Control = styled(Box)(({ theme }) => ({}));
export const Controls = styled(Box)(({ theme }) => ({}));
export const TextOption = styled('i')(({ theme }) => ({
  fontFamily: fonts.MediumItalic,
  fontSize: '13px',
  color: colors.gray,
  marginLeft: '8px',
}));
export const TextRequired = styled('span')(({ theme }) => ({
  fontFamily: fonts.Medium,
  fontSize: '13px',
  color: colors.red,
}));

export default {};
